<template>
  <div class="news-content-container">
    <div class="news-content-inner">
      <div class="title-box">{{ $t('相关信息') }}</div>
      <!--      {{eleConfig.gap}}-->
      <a-row :gutter="[24, 24]">
        <a-col v-for="item in dataList" :key="item._id" :span="8">
          <div class="news-item" @click="goPage(item)">
            <img class="news-image" :src="getImagePath(item)" />
            <div class="news-title">{{ $dt(item, 'name') }}</div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import defaultTopImage from '../../../public/static/customPage/defaultTop.png'

export default {
  name: "linkPages",
  props: {
    dataList: { type: Array, default: () => [] }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    getImagePath(item) {
      const image = item.image?.[0];
      return image?.filePath ? this.$Dolphin.path.publicPath + image.filePath : defaultTopImage;
    },
    goPage(item) {
      if (item.type === 'page' || item.link) {
        this.$router.push(item.link || `/${item._id}`);
      }
    },
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
.news-content-container {
  width: 100%;
  padding: 96px 0;
  background-color: #ECF1FB;

  .news-content-inner {
    width: 1280px;
    margin: 0 auto;
  }

  .title-box {
    font-size: 32px;
    line-height: 45px;
    font-weight: 600;
    margin-bottom: 24px;
    color: #003C82;
  }

  .news-item {
    height: 100%;
    cursor: pointer;
  }

  .news-image {
    height: 260px;
    width: 100%;
    object-fit: cover;
  }

  .news-title {
    font-size: 24px;
    font-weight: 600;
    color: #003C82;
    padding: 12px 16px;
    background-color: white;
  }
}

</style>
